import React from "react";
import MainContainer from "../../components/MainContainer";
import {Link} from "react-router-dom";

const ChooseOfficerActionPage = () => {
	return (
			<MainContainer>
				<div className="col-lg-12">
					<Link to="/ticket-office/confirmation" className="btn btn-back mb-4">
						<svg
								className="govgr-svg-icon--caret govgr-svg-icon"
								focusable="false"
								viewBox="0 0 24 24"
								aria-hidden="true"
						>
							<path d="M18,22V2L6,12L18,22z"></path>
						</svg>
						Πίσω
					</Link>
					<h2 className="mb-4">Eπιλέξτε χρήστη</h2>
					<div className="row justify-content-center">
						<div className="col-md-6 mb-3">
							<Link
									//to="/ticket-office/ticket-info?user=foreigner"
									to="#"
									className="btn btn-primary w-100 d-flex justify-content-center"
									style={{ minHeight: 240, cursor: 'not-allowed', background: 'gray' }}
							>
              <span className="my-auto">
                <h2>Αλλοδαπός Φίλαθλος</h2>
                <p className="white">
                  Αλλοδαπός πολίτης που δεν έχει κάνει αυθεντικοποίηση του
                  εγγράφου πιστοποίησής του μέσω Gov.gr Wallet.
                </p>
              </span>
							</Link>
						</div>
						<div className="col-md-6 mb-3">
							<Link
									to="/ticket-office/ticket-info?user=over-67"
									className="btn btn-primary w-100 d-flex justify-content-center"
									style={{ minHeight: 240 }}
							>
              <span className="my-auto">
                <h2>Ημεδαπός Φίλαθλος άνω των 67 ετών</h2>
                <p className="white">
                  Ημεδαπός Φίλαθλος ηλικίας άνω των 67. Απαιτείται εκτύπωση του
                  εισιτηρίου.
                </p>
              </span>
							</Link>
						</div>
						<div className="col-md-6 mb-3">
							<Link
									to="/ticket-office/transfer-events"
									className="btn btn-primary w-100 d-flex justify-content-center"
									style={{ minHeight: 240 }}
							>
              <span className="my-auto">
                <h2>Διαχείριση Μεταβιβάσεων</h2>
                <p className="white">
                  Καθορισμός μεταβιβάσεων εισιτηρίων σε τρίτους. Ρυθμίσεις για τη χρήση τους.
                </p>
              </span>
							</Link>
						</div>
						<div className="col-md-6 mb-3">
							<Link
									to="/ticket-office/transfer-stats"
									className="btn btn-primary w-100 d-flex justify-content-center"
									style={{ minHeight: 240 }}
							>
              <span className="my-auto">
                <h2>Στατιστικά Μεταβιβάσεων</h2>
                <p className="white">
                  Προβολή στατιστικών στοιχείων για τις μεταβιβάσεις εισιτηρίων.
                </p>
              </span>
							</Link>
						</div>
					</div>
				</div>
			</MainContainer>
	);
};

export default ChooseOfficerActionPage;
